export type WorkspaceAdmissionShellVariant = 'thread' | 'design' | 'generic';

/**
 * Which placeholder the workspace boundary shows while it admits the user.
 * Only routes that share the default thread sidebar get a sidebar shell;
 * every other workspace route keeps the plain full-screen loader, because
 * its layout (or sidebar configuration) differs.
 */
export function resolveWorkspaceAdmissionShellVariant(
  pathname: string | null | undefined
): WorkspaceAdmissionShellVariant {
  const segments = (pathname ?? '').split('/').filter(Boolean);
  if (segments.length < 2) return 'generic';
  if (segments[1] === 'threads' && segments.length >= 3) return 'thread';
  if (segments[1] === 'design' && segments.length === 2) return 'design';
  return 'generic';
}
